import forBasicControl from "./forBasicControl";
import { IControlProps, IListOption, IBasicControlDefinition } from "./types";
import React, { PureComponent } from "react";
import { FormGroup, Input, FormFeedback } from "reactstrap";
import { createLabel } from "./BasicControls";
import LabelWithToolTip from "../LabelWithToolTip";

export interface IOptionSetControl extends IBasicControlDefinition {
    loadOptions: (context: any) => Promise<IListOption<number | string>[]>
    addDefault?: boolean;
}

interface IState {
    loadError: boolean;
    options: IListOption<number | string>[];
    output: string | number;
    value: string;
}

class OptionSetControl extends PureComponent<IControlProps<number | string, IOptionSetControl>, IState> {
    constructor(props) {
        super(props);

        this.state = {
            loadError: false,
            options: null,
            output: null,
            value: null,
        };
    }
    private mountState = false;
    public componentDidMount() {
        this.mountState = true;
        if (!this.state.options) {
            this.load();
        }
        this.setState({
            value: this.props.value ? this.props.value.toString() : null,
            output: this.props.value,
        });
    }
    public componentWillUnmount() {
        this.mountState = false;
    }
    public componentDidUpdate(prev: IControlProps<number | string, IOptionSetControl>) {
        if (this.props.context !== prev.context)
            this.load();
        if (this.props.value !== prev.value)
            this.setState({
                value: this.props.value ? this.props.value.toString() : null,
                output: this.props.value,
            });
    }
    private async load() {
        try {
            const data = await this.props.definition.config.loadOptions(this.props.context);

            if (!this.mountState)
                return;

            this.setState({ loadError: false, options: data });
        }
        catch (e) {
            if (!this.mountState)
                return;

            this.setState({ loadError: true, options: [] });
        }
    }
    private onChange(value: string) {
        let result: string | number = value;

        if (!value) {
            result = null;
        }
        else if (this.state.options && this.state.options.length > 0) {
            if (typeof (this.state.options[0].value) === 'number')
                result = parseInt(value, 10);
        }

        if (value !== this.state.value)
            this.setState({ output: result, value });
        if (result !== this.state.output)
            this.props.onChange(result);
    }
    public render() {
        const props = this.props;
        return <>
            <LabelWithToolTip
                label={createLabel(props.definition, true)}
                field={props.definition.key}
                tooltip={props.definition.config.description}/>

            <Input
                key={this.props.definition.key}
                id={this.props.definition.key}
                disabled={!this.state.options || this.state.loadError}
                invalid={this.props.showValidation && !this.props.isValid}
                onBlur={() => this.props.onBlur()}
                onChange={(evt) => this.onChange(evt.target.value)}
                readOnly={this.props.readOnly}
                type="select"
                valid={this.props.showValidation && this.props.isValid}
                value={this.state.output || ''}
            >
                {this.state.loadError
                    ? <option> - Fout bij laden -</option>
                    : this.state.options
                        ? <>
                            {this.props.definition.config.addDefault && <option value=""> - Selecteer een optie - </option>}
                            {this.state.options.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
                        </>
                        : <option> - Bezig met laden - </option>
                }
            </Input>
        </>
    }
}

const Control = forBasicControl((props: IControlProps<number, IOptionSetControl>) =>
    <FormGroup>
        <OptionSetControl {...props} />
        {!props.isValid && <FormFeedback valid={false} >{props.validationMessage}</FormFeedback>}
    </FormGroup>);

export default Control;